import type { useApiFetch } from '@/features/auth'
import type { MarketTickerResponse } from '@/features/market-data/types'

type AuthedFetch = ReturnType<typeof useApiFetch>

export function fetchMarketTicker(authedFetch: AuthedFetch): Promise<MarketTickerResponse> {
  return authedFetch<MarketTickerResponse>('/api/v1/market-data/ticker')
}
